import { reactive } from 'vue'
import moment from '@/util/MPMoment'

/*
 * 시트 갱신 신호 — 구 V2ReservationManagementDataController 에서 갱신 신호만 떼어냈다
 * (MDP-2295 ④-5 1단계).
 *
 * 시트는 로컬 변경만으로 데이터를 다시 읽지 않는다. 재조회는 여기 값이 바뀔 때 일어나고,
 * 화면들은 그 필드를 watch 한다. 값으로 쓰는 moment 자체에는 의미가 없다 —
 * "새 값으로 바뀌었다" 는 사실만이 신호다.
 *
 * - refreshFlagMoment         : 시트 전체 갱신. 날짜 변경·FCM 수신·새로고침 버튼·저장 성공 후
 * - refreshDateNoteFlagMoment : 날짜 메모만
 * - reservationRefreshEvent   : 예약 이벤트 전용 채널 — 지정한 열만 다시 읽는다
 *
 * 구 컨트롤러에서는 handleRefresh() 를 두고도 절반의 호출부가 refreshFlagMoment 에
 * 직접 대입했다. 여기서는 신호를 바꾸는 길을 아래 세 함수로만 남긴다.
 */

export type ReservationRefreshEvent = {
    columnIDs: string[]
    isAllColumns: boolean
}

export const sheetRefresh = reactive({
    refreshFlagMoment: undefined as unknown,
    refreshDateNoteFlagMoment: undefined as unknown,
    reservationRefreshEvent: { columnIDs: [], isAllColumns: false } as ReservationRefreshEvent,
})

/** 시트 전체 갱신 요청 */
export function handleRefresh(): void {
    sheetRefresh.refreshFlagMoment = moment()
}

/** 날짜 메모 갱신 요청 */
export function handleDateNoteRefresh(): void {
    sheetRefresh.refreshDateNoteFlagMoment = moment()
}

/**
 * 예약 이벤트 갱신 요청.
 *
 * @param columnIDs    다시 읽을 열의 ID
 * @param isAllColumns 전체 열 조회 여부 (columnIDs 가 비면 안전 폴백으로 true)
 */
export function requestReservationRefresh(
    { columnIDs = [], isAllColumns = false }: { columnIDs?: unknown[]; isAllColumns?: boolean } = {},
): void {
    const validIDs = columnIDs.filter((id) => id !== undefined && id !== '')

    sheetRefresh.reservationRefreshEvent = {
        columnIDs: validIDs.map((id) => String(id)),
        isAllColumns: isAllColumns || validIDs.length === 0,
    }
}
